<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="4">
        <el-form-item label="小区名称" prop="propertyId">
          <!-- <el-select
            v-model="query.propertyIds"
            multiple
            placeholder="请选择小区（可多选）"
            style="width: 100%;"
          >
            <el-option
              v-for="item in allPropertyList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select> -->

          <avue-input-tree
            :default-expand-all="true"
            multiple
            v-model="query.propertyIds"
            placeholder="请选择内容"
            type="tree"
            :dic="allPropertyList"
          ></avue-input-tree>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="费项" prop="feeSort">
          <el-select v-model="query.feeSort" placeholder="全部" style="width: 100%;">
            <el-option
              v-for="item in allSortTypeList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="收费日期 从" prop="dateRange">
          <el-date-picker
              style="width:42%;"
              v-model="query.dateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00.000"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.dateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59.999"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            @click.prevent="submitSearchForm"
            >搜索</el-button
          >
          <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel()"
          >导 出
        </el-button>
      </template>
      <template slot="cashRatio" slot-scope="scope">
        <span>{{ ratioShow(scope.row.cashTotalPayCount, scope.row.sumTotalPayCount) }}
        </span>
      </template>
      <template slot="onLineRatio" slot-scope="scope">
        <span>{{ ratioShow(scope.row.onLineTotalPayCount, scope.row.sumTotalPayCount) }}
        </span>
      </template>
      <template slot="bankRatio" slot-scope="scope">
        <span>{{ ratioShow(scope.row.bankTotalPayCount, scope.row.sumTotalPayCount) }}
        </span>
      </template>
      <template slot="otherRatio" slot-scope="scope">
        <span>{{ ratioShow(scope.row.otherTotalPayCount, scope.row.sumTotalPayCount) }}
        </span>
      </template>
      <template slot="sumRatio" slot-scope="scope">
        <span>{{ ratioShow(scope.row.sumTotalPayCount, scope.row.sumTotalPayCount) }}
        </span>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { paySummarize, paySummarizeExcel } from '@/api/v4ward/paylist/feepaylist';
import { mapGetters } from 'vuex';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';
import { getDictionary } from '../../../api/common';

export default {
  data() {
    return {
      dateRange: [],
      allPayTypeList: [],
      allPropertyList: [
        {
          label: '---------全部小区----------',
          value: '',
          children: [],
        },
      ],
      allSortTypeList: [],
      propertyName: '',
      form: {},
      query: {
        propertyIds: [],
        propertyIdsStr: '',
        feeSort: '',
        dateFrom: '',
        dateTo: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '小区名称',
            prop: 'roomName',
          },
          {
            label: '现金缴费',
            children: [
              {
                label: '缴费笔数',
                prop: 'cashTotalPayCount',
              },
              {
                label: '应缴金额',
                prop: 'cashTotalShouldAmount',
              },
              {
                label: '缴费金额',
                prop: 'cashTotalPayAmount',
              },
              {
                label: '比例',
                prop: 'cashRatio',
                slot: true,
              },
            ],
          },
          {
            label: '在线支付',
            children: [
              {
                label: '缴费笔数',
                prop: 'onLineTotalPayCount',
              },
              {
                label: '应缴金额',
                prop: 'onLineTotalShouldAmount',
              },
              {
                label: '缴费金额',
                prop: 'onLineTotalPayAmount',
              },
              {
                label: '比例',
                prop: 'onLineRatio',
                slot: true,
              },
            ],
          },
          {
            label: '银行代扣',
            children: [
              {
                label: '缴费笔数',
                prop: 'bankTotalPayCount',
              },
              {
                label: '应缴金额',
                prop: 'bankTotalShouldAmount',
              },
              {
                label: '缴费金额',
                prop: 'bankTotalPayAmount',
              },
              {
                label: '比例',
                prop: 'bankRatio',
                slot: true,
              },
            ],
          },
          {
            label: '其他收费',
            children: [
              {
                label: '缴费笔数',
                prop: 'otherTotalPayCount',
              },
              {
                label: '应缴金额',
                prop: 'otherTotalShouldAmount',
              },
              {
                label: '缴费金额',
                prop: 'otherTotalPayAmount',
              },
              {
                label: '比例',
                prop: 'otherRatio',
                slot: true,
              },
            ],
          },
          {
            label: '缴费汇总',
            children: [
              {
                label: '缴费笔数',
                prop: 'sumTotalPayCount',
              },
              {
                label: '应缴金额',
                prop: 'sumTotalShouldAmount',
              },
              {
                label: '缴费金额',
                prop: 'sumTotalPayAmount',
              },
              {
                label: '比例',
                prop: 'sumRatio',
                slot: true,
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankchangeinfo_add, false),
        viewBtn: this.vaildData(this.permission.basebankchangeinfo_view, false),
        delBtn: this.vaildData(this.permission.basebankchangeinfo_delete, false),
        editBtn: this.vaildData(this.permission.basebankchangeinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initDefaultDateRange();
    this.initPropertyList();
    this.initSortTypeList();
    this.initPayTypeList();
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.tool.clearObject(this.query);
      this.initDefaultDateRange()
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      //this.initPropertyList();
      this.searchChange(this.query);
    },
    onLoad(page) {
      
      page = page || this.page;
      this.loading = true;
      if (this.query.propertyIds) this.query.propertyIdsStr = this.query.propertyIds.join(',');
      // if (!this.query.propertyId) {
      //   getOptionNode({}).then((data) => {
      //     this.query.propertyId = data.data[0].id;
      //     paySummarize(
      //       Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
      //     ).then(({ data }) => {
      //       this.page.total = data.total;
      //       this.data = data.records;
      //       this.loading = false;
      //       this.selectionClear();
      //     });
      //   });
      //   return;
      // }
      paySummarize(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      this.query.dateFrom=this.getCurrentMonthFirst() + " 00:00:00.000"
      this.query.dateTo=this.getCurrentMonthLast() +" 23:59:59.999"
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initPropertyList() {
      getOptionNode({ shortCode: this.query.shortCode }).then((data) => {
        this.allPropertyList[0].children = data.data;

        this.allPropertyList[0].children.forEach((v, i) => {
          // console.log(i,v);
          v.label = v.title;
          v.value_ = v.value;
          v.value = v.id;

          this.allPropertyList[0].children[i] = v;
        });
      });
    },

    initSortTypeList: function () {
      getDictionary('fee_sort').then((data) => {
        this.allSortTypeList = data.data;
      });
    },

    initPayTypeList: function () {
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },
    //导出
    exportExcel() {
      this.$confirm('确定导出所有数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        paySummarizeExcel(Object.assign({}, this.query)).then(({ data }) => {
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '小区名称',
              '现金缴费',
              '',
              '',
              '',
              '在线支付',
              '',
              '',
              '',
              '银行代扣',
              '',
              '',
              '',
              '其他收费',
              '',
              '',
              '',
              '缴费汇总',
              '',
              '',
              '',
            ]; // 导出excel 的标题
            const filterVal = [
              'roomName',
              'cashTotalPayCount',
              'cashTotalShouldAmount',
              'cashTotalPayAmount',
              'cashRatio',
              'onLineTotalPayCount',
              'onLineTotalShouldAmount',
              'onLineTotalPayAmount',
              'onLineRatio',
              'bankTotalPayCount',
              'bankTotalShouldAmount',
              'bankTotalPayAmount',
              'bankRatio',
              'otherTotalPayCount',
              'otherTotalShouldAmount',
              'otherTotalPayAmount',
              'otherRatio',
              'sumTotalPayCount',
              'sumTotalShouldAmount',
              'sumTotalPayAmount',
              'sumRatio',
            ]; // 每个标题对应的字段

            const list = (data || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                roomName: item.roomName,
                cashTotalPayCount: item.cashTotalPayCount,
                cashTotalShouldAmount: item.cashTotalShouldAmount,
                cashTotalPayAmount: item.cashTotalPayAmount,
                cashRatio: this.ratioShow(item.cashTotalPayCount, item.sumTotalPayCount),
                onLineTotalPayCount: item.onLineTotalPayCount,
                onLineTotalShouldAmount: item.onLineTotalShouldAmount,
                onLineTotalPayAmount: item.onLineTotalPayAmount,
                onLineRatio: this.ratioShow(item.onLineTotalPayCount, item.sumTotalPayCount),
                bankTotalPayCount: item.bankTotalPayCount,
                bankTotalShouldAmount: item.bankTotalShouldAmount,
                bankTotalPayAmount: item.bankTotalPayAmount,
                bankRatio: this.ratioShow(item.bankTotalPayCount, item.sumTotalPayCount),
                otherTotalPayCount: item.otherTotalPayCount,
                otherTotalShouldAmount: item.otherTotalShouldAmount,
                otherTotalPayAmount: item.otherTotalPayAmount,
                otherRatio: this.ratioShow(item.otherTotalPayCount, item.sumTotalPayCount),
                sumTotalPayCount: item.sumTotalPayCount,
                sumTotalShouldAmount: item.sumTotalShouldAmount,
                sumTotalPayAmount: item.sumTotalPayAmount,
                sumRatio: this.ratioShow(item.sumTotalPayCount, item.sumTotalPayCount),
              };
            });

            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              data.unshift([
                '',
                '缴费笔数',
                '应缴金额',
                '实收金额',
                '比例',
                '缴费笔数',
                '应缴金额',
                '实收金额',
                '比例',
                '缴费笔数',
                '应缴金额',
                '实收金额',
                '比例',
                '缴费笔数',
                '应缴金额',
                '实收金额',
                '比例',
                '缴费笔数',
                '应缴金额',
                '实收金额',
                '比例',
              ]);
              excel.export_json_to_excel_custom_merge({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename: '收费方式汇总' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            } else {
              this.$message.error('暂无有效数据');
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    payTypeToPayTypeName(payType) {
      var payTypeName = '';
      this.allPayTypeList.forEach(function (value, index, array) {
        if (value.dictKey == payType) {
          payTypeName = value.dictValue;
          return;
        }
      });
      return payTypeName;
    },
    ratioShow(num, total) {
      if (num > 0 && total > 0) {
        return ((num / total) * 100).toFixed(2) + '%';
      }
      return '-';
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: red;
}
</style>
